import React from 'react';
import { Typography } from '@mui/material';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import styled, { css } from 'styled-components';
import { FONT_SIZES, PALETTE } from '~/assets/styles/base';

const StyledTypography = styled(Typography)`
  font-size: ${FONT_SIZES.note1};
  margin-left: 5px;
  margin-top: -2px;
  text-decoration: none;
`;

const HelpWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  background: ${PALETTE.blue.light};
  padding: 7px 10px;
  height: 30px;
  border-radius: 30px;
`;

type StyledLinkProps = {
  $warnTop?: string;
  $warnRight?: string;
  $warnLeft?: string;
  $warnBottom?: string;
  $warnBorder?: string;
  $warnBorderRadius?: string;
  $warnBackground?: string;
};

const StyledLink = styled.a<StyledLinkProps>`
  color: ${PALETTE.text.main};

  ${(props) =>
    (props.$warnTop ||
      props.$warnRight ||
      props.$warnLeft ||
      props.$warnBottom ||
      props.$warnBorder ||
      props.$warnBorderRadius ||
      props.$warnBackground) &&
    css`
      position: absolute;
      top: ${props.$warnTop};
      right: ${props.$warnRight};
      bottom: ${props.$warnBottom};
      left: ${props.$warnLeft};
      border: ${props.$warnBorder};
      border-radius: ${props.$warnBorderRadius};
      background: ${props.$warnBackground};
    `}
  text-decoration: none;
  &:visited {
    color: ${PALETTE.text.main};
  }
  &:hover {
    opacity: 0.6;
  }
`;
type Props = {
  warnText: string;
  warnTop?: string;
  warnRight?: string;
  warnBottom?: string;
  warnLeft?: string;
  warnBorder?: string;
  warnBorderRadius?: string;
  warnBackground?: string;
  warnLink: string;
};

const HelpLink: React.FC<Props> = ({
  warnText,
  warnTop = '',
  warnRight = '',
  warnLeft = '',
  warnBottom = '',
  warnBorder = '',
  warnBorderRadius = '',
  warnBackground = '',
  warnLink,
}): JSX.Element => (
  <StyledLink
    $warnTop={warnTop}
    $warnRight={warnRight}
    $warnLeft={warnLeft}
    $warnBottom={warnBottom}
    $warnBorder={warnBorder}
    $warnBorderRadius={warnBorderRadius}
    $warnBackground={warnBackground}
    href={warnLink}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="uiParts-HelpLink-Link"
  >
    <HelpWrapper data-testid="uiParts-HelpLink-Wrapper">
      <QuestionMarkIcon
        sx={{
          width: 16,
          height: 16,
          background: PALETTE.primary.main,
          color: PALETTE.white,
          borderRadius: '50%',
        }}
        data-testid="uiParts-HelpLink-Icon"
      />
      <StyledTypography data-testid="uiParts-HelpLink-Text">{warnText}</StyledTypography>
    </HelpWrapper>
  </StyledLink>
);

export default HelpLink;
